import React, { useState, useEffect } from "react";

import ScaricaButton from "../box_button/scarica_app_button.js";
import ChatAssistenza from "../box_button/chat_assistenza_button.js";
import Promotion from "../box_button/promotion_button.js";

import { useTranslation } from "react-i18next";

import chat from "./assets/chat.png";

import gift from "./assets/gift.png";

function BoxNavigationFooter() {
    const { t } = useTranslation();
    return (
        <>
            <div className="container-fluid box-underCarousel">
                <div className="row">
                    {/* <div className="col-12">
         <div className="box-navigation boxNav-chat" >
            <div className="text">
               <h4>{t('Chat_live')}</h4>
               <a href="javascript:SBChat.initChat();SBChat.open()">{t('Do_you_need_help?')}</a>
            </div>
            <img src="/assets/img/chat.png"/>
         </div>
      </div> */}
                    {/* <div className="col-12">
         <div className="box-navigation promotionbox">
            <div className="text">
               <h4>{t('Promotions')}</h4>
               <p>{t('Discover_all_our_offers')}</p>
            </div>
            <img src="/assets/img/gift.png"/>
         </div>
      </div> */}
                </div>
            </div>
        </>
    );
}

export default BoxNavigationFooter;
